import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-analogue-supplier-group-select-dialog',
  templateUrl: './analogue-supplier-group-select-dialog.component.html',
  styleUrls: ['./analogue-supplier-group-select-dialog.component.scss']
})
export class AnalogueSupplierGroupSelectDialogComponent {
  selectedSubGroupCode: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public readonly data: {
      providerName: string;
      contractNumber?: string | null;
      productTitle?: string | null;
      lookupArticle?: string | null;
      availableSubGroupCodes: string[];
    },
    private readonly dialogRef: MatDialogRef<AnalogueSupplierGroupSelectDialogComponent>
  ) {
    this.selectedSubGroupCode = data.availableSubGroupCodes[0] || '';
  }

  select(subGroupCode: string) {
    this.selectedSubGroupCode = subGroupCode;
  }

  close() {
    this.dialogRef.close(null);
  }

  confirm() {
    if (!this.selectedSubGroupCode) {
      return;
    }

    this.dialogRef.close(this.selectedSubGroupCode);
  }
}
